module.exports = __webpack_public_path__ + "static/img/1.481e4bf3.png";